export default __webpack_public_path__ + "static/media/pt-white.72edb1c3.svg";